import { apiFetch } from './client';
export async function patchSection(sectionId, payload) {
    await apiFetch(`/sections/${sectionId}`, {
        method: 'PATCH',
        body: JSON.stringify(payload),
    });
}
